"use strict";
exports.__esModule = true;
exports.StaticBlockDefinition = exports.StaticBlock = void 0;
var text_1 = require("../../../utils/text");
var StaticBlock = /** @class */ (function () {
    function StaticBlock(blockDef, placeholder) {
        this.blockDef = blockDef;
        var element = document.createElement('div');
        if (this.blockDef.meta.html) {
            element.innerHTML = this.blockDef.meta.html;
        }
        else {
            element.innerHTML = text_1.escapeHtml(this.blockDef.meta.text);
        }
        placeholder.replaceWith(element);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    StaticBlock.prototype.setState = function (_state) { };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    StaticBlock.prototype.setError = function (_errorList) { };
    StaticBlock.prototype.getState = function () {
        return null;
    };
    StaticBlock.prototype.getValue = function () {
        return null;
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    StaticBlock.prototype.focus = function () { };
    return StaticBlock;
}());
exports.StaticBlock = StaticBlock;
var StaticBlockDefinition = /** @class */ (function () {
    function StaticBlockDefinition(name, meta) {
        this.name = name;
        this.meta = meta;
    }
    StaticBlockDefinition.prototype.render = function (placeholder) {
        return new StaticBlock(this, placeholder);
    };
    return StaticBlockDefinition;
}());
exports.StaticBlockDefinition = StaticBlockDefinition;
